import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { format } from "date-fns";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuItem } from "primeng/api";
import { SubSink } from "subsink/dist/subsink";
import { PpsUtilityService } from "../services/pps-utility.service";
import { ReportService } from "../services/report.service";
import { PoInvoiceDiscrepancyReportData } from "../shared/models/po-discrepancy-report-data";
import { PoInvoiceDiscrepancyReportItem } from "./po-discrepancy-report-item";

@Component({
  selector: "pps-po-invoice-discrepancy-report",
  templateUrl: "./po-invoice-discrepancy-report.component.html",
  styles: [
    `#po-invoice-discrepancy-table .p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):hover td{
      background: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.87);
    }`  
  ],
  encapsulation: ViewEncapsulation.None
})
export class PoInvoiceDiscrepancyReportComponent implements OnInit, OnDestroy{
  private subs = new SubSink();
  smallScreen = false;

  items: MenuItem[] = [{label: "Report", icon: "pi-fw fas fa-table"}, {label: "PO/Invoice Discrepancy Report", icon: "pi-fw far fa-file-excel"}];
  spinnerName: string = "spinner";
  exporting = false;

  reportItems: PoInvoiceDiscrepancyReportItem[] = [];
  message: string = "";

  constructor(private _reportService: ReportService,
    private spinner: NgxSpinnerService,
    public util: PpsUtilityService){}

  ngOnInit(): void {
    this.loadReportData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
  
  loadReportData(){
    this.spinner.show(this.spinnerName);
    this.reportItems = [];
    this.subs.sink = this._reportService.getPoDiscrepancyReportData()
      .subscribe(res => {
        if (res.succeed){
          let reportData: PoInvoiceDiscrepancyReportData = res.result;
          // for each PO number
          reportData.nonmatchPoList.forEach(po => {
            let poAmnount = reportData.poProjectsLookup[po].reduce((sum, cur) => sum + (cur.poAmount || 0), 0);
            let totalPoInvoiceValue = 0;
            reportData.poProjectsLookup[po].forEach(p=>{
              let poInvoiceValue = 0;
              if (p.invoices.length > 0){
                poInvoiceValue = p.invoices.reduce((sum,cur) => sum + cur.invoiceValue, 0);
              }

              totalPoInvoiceValue += poInvoiceValue;
            });

            reportData.poProjectsLookup[po].forEach((prj, prjIndex) =>{
              if (prj.invoices.length > 0){
                let invoiceTotal = prj.invoices.reduce((sum,cur) => sum + cur.invoiceValue, 0);
                prj.invoices.forEach((inv, invoiceIndex) => {
                  let item = new PoInvoiceDiscrepancyReportItem ();
                  if (invoiceIndex === 0){
                    if (prjIndex === 0){
                      item.poNo = po;
                      item.poAmount = this.util.formatCurrency(poAmnount);
                      item.totalPoInvoiceValue = this.util.formatCurrency(totalPoInvoiceValue);
                    }
                    item.projectNo = prj.projectNo;
                    item.projectDescription = prj.description;
                    item.installationProgress = prj.installationProgress?.name;
                    item.totalProjectInvoiceValue = this.util.formatCurrency(invoiceTotal);
                  }
                  item.invoiceNo = inv.invoiceNo;
                  item.invoiceDate = this.util.getDateString(new Date(inv.invoiceDate));
                  item.incomeMonth = format(new Date(inv.invoiceDate), "MMMM, yyyy");
                  item.invoiceValue = this.util.formatCurrency(inv.invoiceValue);
                  this.reportItems.push(item);
                });
              }else{
                let item = new PoInvoiceDiscrepancyReportItem ();
                if (prjIndex === 0){
                  item.poNo = po;
                  item.poAmount = this.util.formatCurrency(poAmnount);
                  item.totalPoInvoiceValue = this.util.formatCurrency(totalPoInvoiceValue);
                }
                item.projectNo = prj.projectNo;
                item.projectDescription = prj.description;
                item.installationProgress = prj.installationProgress?.name;
                item.totalProjectInvoiceValue = this.util.formatCurrency(0);
                this.reportItems.push(item);
              }
            });
          })
        }
      }, 
      error => {},
      ()=> {
        this.spinner.hide(this.spinnerName);
      });
  }

  exportToExcel(){
    this.spinner.show(this.spinnerName);
    this.exporting = true;
    this._reportService.generatePoInvoiceDiscrepancyReport(
      () => {
        this.spinner.hide(this.spinnerName);
        this.exporting = false;
      });
  }
  rowGroupMetadata: any;

  onSort(){
  }
}